module.exports = __webpack_public_path__ + "img/logo.b032a33e.png";